import ScrollToTop from "./components/ScrollToTop/ScrollToTop.js";
import Navigation from "./components/Common/Header/Header";
import Breadcrumb from "./components/Common/Breadcrumb/Breadcrumb";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import MeetTeam from "./components/About/MeetTeam";

import StudentVisas from "./components/Services/StudentVisas";
import SkilledVisas from "./components/Services/SkilledVisas";
import EmployerVisas from "./components/Services/EmployerVisas";
import FamilyVisas from "./components/Services/FamilyVisas";
import VisitorVisas from "./components/Services/VisitorVisas";
import ReferFriend from "./components/ReferFriend/ReferFriend";
import LabourAgreements from "./components/Services/LabourAgreements";
import SkillsAssessment from "./components/Services/SkillsAssessment";
import DAMA from "./components/Services/DAMA";
import ArtVisaAppeals from "./components/Services/ArtVisaAppeals";
import HealthInsuarance from "./components/Services/HealthInsuarance";
import ProfessionalYear from "./components/Services/ProfessionalYear";

import EarlyChild from "./components/Courses/EarlyChild.js";
import Nursing from "./components/Courses/Nursing.js";
import SocialWork from "./components/Courses/SocialWork.js";
import BuildConstru from "./components/Courses/BuildConstru.js";
import InfoTech from "./components/Courses/InfoTech.js";
import Engineer from "./components/Courses/Engineer.js";
import Accounting from "./components/Courses/Accounting.js";
import OccupationalTherapy from "./components/Courses/OccupationalTherapy.js";
import AutoTech from "./components/Courses/AutoTech.js";
import Cookery from "./components/Courses/Cookery.js";

import PTE from "./components/Coaching/PTE.js";
import IELTS from "./components/Coaching/IELTS.js";
import NAATI from "./components/Coaching/NAATI.js";

import Introduction from "./components/CorporateServices/Introduction.js";
import SponsorVisaApp from "./components/CorporateServices/SponsorVisaApp.js";
import SkillInDemand from "./components/CorporateServices/SkillInDemand.js";
import EmployerNomVisa from "./components/CorporateServices/EmployerNomVisa.js";
import SkilledEmpSponRegionVisa  from "./components/CorporateServices/SkilledEmpSponRegionVisa .js";
import SponsorOblig  from "./components/CorporateServices/SponsorOblig.js";
import AppealingSponsoeVisa  from "./components/CorporateServices/AppealingSponsoeVisa.js";




import Blog from "./components/Blog/Blog";
import ContactUs from "./components/ContactUs/ContactUs";
import BlogDetails from "./components/BlogDetails/BlogDetails";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import RefundPolicy from "./components/RefundPolicy/RefundPolicy";
import TermsConditions from "./components/TermsConditions/TermsConditions";
import TermsOfUse from "./components/TermsOfUse/TermsOfUse";
import ConsultationTermsConditions from "./components/ConsultationTermsConditions/ConsultationTermsConditions";
import Footer from "./components/Common/Footer/Footer.js";
import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/MeetTeam" element={<MeetTeam />} />

          <Route path="/StudentVisas" element={<StudentVisas />} />
          <Route path="/SkilledVisas" element={<SkilledVisas />} />
          <Route path="/EmployerVisas" element={<EmployerVisas />} />
          <Route path="/FamilyVisas" element={<FamilyVisas />} />
          <Route path="/VisitorVisas" element={<VisitorVisas />} />
          <Route path="/LabourAgreements" element={<LabourAgreements />} />
          <Route path="/SkillsAssessment" element={<SkillsAssessment />} />
          <Route path="/DAMA" element={<DAMA />} />
          <Route path="/ArtVisaAppeals" element={<ArtVisaAppeals />} />
          <Route path="/ReferFriend" element={<ReferFriend />} />



          <Route path="/PTE" element={<PTE />} />
          <Route path="/IELTS" element={<IELTS />} />
          <Route path="/NAATI" element={<NAATI />} />

          <Route path="/Introduction" element={<Introduction />} />
          <Route path="/SponsorVisaApp" element={<SponsorVisaApp />} />
          <Route path="/SkillInDemand" element={<SkillInDemand />} />
          <Route path="/EmployerNomVisa" element={<EmployerNomVisa />} />
          <Route path="/SkilledEmpSponRegionVisa" element={<SkilledEmpSponRegionVisa />} />
          <Route path="/SponsorOblig" element={<SponsorOblig />} />
          <Route path="/AppealingSponsoeVisa" element={<AppealingSponsoeVisa />} /> 


          <Route path="/HealthInsuarance" element={<HealthInsuarance />} />
          <Route path="/ProfessionalYear" element={<ProfessionalYear />} />
          <Route path="/EarlyChild" element={<EarlyChild />} />
          <Route path="/Nursing" element={<Nursing />} />
          <Route path="/SocialWork" element={<SocialWork />} />
          <Route path="/BuildConstru" element={<BuildConstru />} />
          <Route path="/InfoTech" element={<InfoTech />} />
          <Route path="/Engineer" element={<Engineer />} />
          <Route path="/Accounting" element={<Accounting />} />
          <Route
            path="/OccupationalTherapy"
            element={<OccupationalTherapy />}
          />
          <Route path="/AutoTech" element={<AutoTech />} />
          <Route path="/Cookery" element={<Cookery />} />

          <Route path="/Blog" element={<Blog />} />
          <Route path="/BlogDetails/:slug" element={<BlogDetails />} />
          <Route path="/ContactUs" element={<ContactUs />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/RefundPolicy" element={<RefundPolicy />} />
          <Route path="/TermsConditions" element={<TermsConditions />} />
          <Route path="/TermsOfUse" element={<TermsOfUse />} />
          <Route
            path="/ConsultationTermsConditions"
            element={<ConsultationTermsConditions />}
          />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
